import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

const cities = [
  "Phoenix", "Scottsdale", "Mesa", "Tempe", "Chandler", "Glendale",
  "Peoria", "Gilbert", "Surprise", "Goodyear", "Avondale", "Buckeye",
  "Queen Creek", "Apache Junction", "Paradise Valley", "Fountain Hills",
];

const CityGrid = () => {
  return (
    <section className="py-16 md:py-24 bg-surface-alt">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold mb-3">Insurance Across Arizona</h2>
          <p className="text-muted-foreground max-w-prose-wide mx-auto leading-relaxed">
            Local expertise in 100+ Arizona communities. Find a broker who knows your neighborhood.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {cities.map((city) => (
            <Link
              key={city}
              to={`/az/${city.toLowerCase().replace(/ /g, "-")}`}
              className="group flex items-center gap-2 bg-surface rounded-xl px-4 py-3.5 shadow-card hover:shadow-elevated transition-all duration-200"
            >
              <MapPin className="w-4 h-4 text-primary shrink-0" />
              <span className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                {city}
              </span>
            </Link>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/cities"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:text-primary/80 transition-colors"
          >
            View all 100+ Arizona cities <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CityGrid;
